import { createContext } from 'react'

const PropertyTreeContext = createContext({
  treeId: '',
  splitterTransparentBarWidth: 0,
  nodeHeight: 0,
  name: ''
})
export { PropertyTreeContext }
